<template>
  <Main>
    <div v-if="showTermDialog">
      <termList v-on:agreeList="agreeListHide" v-on:e_Callback="ListHide" type="doctor_reg"></termList>
    </div>
    <infoForm ref="infoForm" title="注册" fromType="register" :isRegister="true" @on-submit="submitHandle" submit="提交" align="返回登录" @on-align="onAlign">
      <el-form-item slot="forget" prop="captcha">
        <div class="register-container">
          <input class="register-input" v-model="registerCaptcha" placeholder="短信验证" type="text">
          <el-button class="get-captcha" size="mini" slot="append" @click="sendPhoneCode" :disabled="sendCodeBtnDisable">{{ code_tip }}</el-button>
        </div>
      </el-form-item>
      <el-form-item slot="termHandle" class="agree-radio-form">
        <label class="agreeRadio">
          <!-- <checkbox class="register-checkbox" v-model="isAgree"></checkbox> -->
          <input type="checkbox" class="register-checkbox" v-model="isAgree">
          <span class="agree-span">已同意相关的协议</span>
          <span class="mainTextColor" @click="termHandle()">《服务和隐私协议》</span>
        </label>
      </el-form-item>
    </infoForm>
  </Main>
</template>

<script>
import infoForm from "@/components/infoForm/index.vue";
import util from "@/utils";
import termList from "@/components/common/termList";
import Main from "@/components/main/main.vue";
export default {
  name: "",
  components: {
    infoForm,
    termList,
    Main
  },
  props: {},
  data() {
    return {
      code_time: 60,
      code_tip: "发送验证码",
      sendCodeBtnDisable: false,
      showTermDialog: false,
      isAgree: false,
      registerCaptcha: "",
      icp_number: process.env.VUE_APP_ICP_NUMBER,
      websiteTitle: process.env.VUE_APP_WEBSITE_TITLE,
    };
  },
  created() { },
  mounted() { },
  activited() { },
  update() { },
  beforeRouteUpdate() { },
  methods: {
    onAlign(type) {
      this.go("/login");
    },

    go(url) {
      this.$router.push({
        path: url,
      });
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    /*监听同意按钮*/
    agreeListHide: function () {
      this.isAgree = true;
      this.showTermDialog = false;
    },
    //设置关闭协议弹框后不选中
    ListHide() {
      this.isAgree = false;
      this.showTermDialog = false;
    },
    termHandle() {
      this.showTermDialog = true;
    },
    /*
     *  注册绑定模式:0, 登录验证:1, 修改密码模式:2, 修改手机号:3；
     * */
    async sendPhoneCode() {
      console.log('sendPhoneCode:',this.$refs.infoForm);
      try {
        /**
         * 获取组件中表单中的手机号码
         */
        let mobile = this.$refs.infoForm.loginForm.username;
        if (mobile === "") {
          this.elementTips("error", "手机号码不能为空");
          return;
        }
        const params = {
          smsMode: "0",
          mobile: mobile,
        };
        let res = await getCaptcha(params);
        if (res.success) {
          this.countDown();
          this.elementTips("success", res.message);
          this.sendCodeBtnDisable = true;
        } else {
          this.sendCodeBtnDisable = false; //错误的情况下 解除禁止
          this.elementTips("warning", res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * 倒计时
     * */
    countDown() {
      const that = this;
      const timer = setInterval(() => {
        that.code_tip = this.code_time + "s";
        that.code_time--;
        if (that.code_time <= 0) {
          clearInterval(timer);
          that.sendCodeBtnDisable = false;
          that.code_tip = "获取验证码";
          that.code_time = 60;
        }
      }, 1000);
    },
    /**
     * 提交注册
     */
    async submitHandle(userInfo) {
      try {
        if (userInfo.password != userInfo.againPassword) {
          this.elementTips("error", "两次密码不一致！");
          return;
        }
        if (!this.isAgree) {
          this.elementTips("error", "请同意使用条款");
          return;
        }
        
        var params = {
          mobile: userInfo.username,
          password: userInfo.password,
          captcha: this.registerCaptcha,
        };
        let res = await publicsReg(params);
        if (res.success) {
          this.elementTips("success", res.message);
          setTimeout(() => {
            this.go("/login");
          }, 1500);
        } else if (res.code === 1000039) {
          //用户已经存在
          this.elementTips("success", res.message);
          setTimeout(() => {
            this.go("/login");
          }, 1000);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.agree-radio-form {
  margin-bottom: -5% !important;
  height: 50px;
}

.register-container {
  position: relative;
  .register-input {
    width: 100%;
    height: 30px;
    border-style: none none none;
    border-bottom: 1px solid #dcdcdc;
    width: calc(100% - 60px);
    background-image: url("../../assets/images/login-code.png");
    background-size: 15px 15px;
    background-position: 3px 8px;
    background-repeat: no-repeat;
    padding: 0 0 0 50px;
  }
  .register-input:focus {
    border-bottom: 1px solid #dcdcdc;
    outline: none;
  }
}
.get-captcha {
  position: absolute;
  top: 4px;
  right: 0;
  background-color: #fff;
  color: #fc701a;
  border: none; // 去掉边框
  outline: none; // 去掉点击按钮后的边框
  cursor: pointer;
}
.login-user:focus {
  outline: none;
}
//   }
.mainTextColor {
  color: #fc701a;
}
.agree-span {
  margin-left: 5%;
}
.agreeRadio {
  input[type="checkbox"] {
    cursor: pointer;
    position: relative;
    top: 2px;
    width: 10px;
    height: 15px;
    font-size: 14px;
  }

  input[type="checkbox"]::after {
    position: absolute;
    top: 0;
    background-color: #fff;
    border: rgb(150, 145, 145) 1px solid;
    color: #f7f2f0;
    width: 15px;
    height: 15px;
    display: inline-block;
    visibility: visible;
    padding-left: 0px;
    text-align: center;
    content: " ";
    border-radius: 3px;
  }

  input[type="checkbox"]:checked::after {
    content: "✓";
    font-size: 12px;
    font-weight: bold;
    background: #fc701a;
    border: #fc701a 1px solid;
  }
}

/deep/ .el-form-item__content {
  line-height: 20px !important;
}

input::-webkit-input-placeholder {
  color: #c0c0c0;
  font-size: 14px;
}
</style>
